import { useCosInfo } from "@/controllers/gridManager/accountsManager/accountManager";
import { getCopierInfo, getHistoryCopyTrans } from "@/controllers/gridManager/followerTransManager/followerTransManager";
import TableUIElement, { Column } from "@/views/components/componentsUI/TableUIElement";
import SelectElement, { ItemOption } from "@/views/elements/select/SelectElement";
import { SelectChangeEvent } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

type Props = {}




export default function CopyInfoHistory({ }: Props) {
    const { t } = useTranslation()
    const { cosInfo } = useCosInfo()
    const { refaccount } = cosInfo
    const [listCopied, setListCopied] = useState<any[]>([])
    const [currentMasterAccount, setCurrentMasterAccount] = useState<string>('')

    const columns: Column[] = [
        { id: 'trantype', label: t("copytrade.followerHistoryTransactions.content"), enableSort: true },
        { id: 'txdate|txtime', label: t("copytrade.followerHistoryTransactions.timeCopy"), alignCell: 'center', align: 'center' },
        { id: 'fullname', label: t("copytrade.followerHistoryTransactions.copier") },
        { id: 'namt', label: t("copytrade.followerHistoryTransactions.numberAmount"), formatNumber: true, enableSort: true, alignCell: 'right', align: 'right' },
    ];

    const objParameterFn: Partial<Parameters<typeof getHistoryCopyTrans>[0]> = {
        accountId: refaccount,
        masterAccount: currentMasterAccount ?? '',
    }

    useEffect(() => {
        // hardcode
        async function callApiCopierInfo(accountId: string) {
            const { isSuccess, data } = await getCopierInfo({
                accountId: accountId
                , masterAccount: '' // get all
            })
            if (isSuccess) {
                const listForOption: [] = data.map((item: any): Partial<ItemOption> => {
                    return {
                        label: item?.fullname ?? '',
                        value: item?.mtacctno ?? '',
                        ...item
                    }
                })
                const ALL: any[] = []// [{ label: 'ALL', value: '' }]
                setListCopied([...ALL, ...listForOption])
            }
        }

        if (refaccount) {
            callApiCopierInfo(refaccount)
        }
    }, [refaccount])

    const handleChangeCurrentMasterAccount = (event: SelectChangeEvent<any>) => {
        const value = event.target.value ?? ''
        setCurrentMasterAccount(value);
    };

    const renderQuery = () => {
        return <>
            <SelectElement
                placeholder={t("copytrade.common.masterTrader")}
                listItems={listCopied}
                value={currentMasterAccount}
                onChange={handleChangeCurrentMasterAccount}
            />
        </>
    }

    return (
        <TableUIElement
            columns={columns}
            fnCallApi={getHistoryCopyTrans}
            objParameterFn={objParameterFn}
            enableDatePicker={true}

            queryBeforeDate={renderQuery}
            listenerQuery={{ currentMasterAccount }}
        />
    )
}